module.exports = __webpack_public_path__ + "static/img/qcode.e3e8f087.jpg";